import Axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FaSpinner } from 'react-icons/fa';
import { useParams } from 'react-router-dom';

export default function ItemDetails() {

    let { id, media_type } = useParams();

    const [itemDetails, setItemDetails] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    async function getItemDetails(id, media_type) {
        let { data } = await Axios.get(`https://api.themoviedb.org/3/${media_type}/${id}?api_key=86a23d94aa6567f63245ba13568ede00&language=en-US`);
        setItemDetails(data);
        setIsLoading(false);
    }

    useEffect(() => {
        getItemDetails(id, media_type);
    }, [id, media_type]);

    return isLoading ? (
        <div className="d-flex flex-row justify-content-center align-items-center vh-100">
            <FaSpinner style={{ fontSize: '90px' }} />
        </div>
    ) : (
        <div className="container py-4">
            <div className="row mb-4">
                <div className="col-md-4 mb-3">
                    {itemDetails.poster_path ? (
                        <img className="w-100" src={`https://image.tmdb.org/t/p/w500/${itemDetails.poster_path}`} alt={itemDetails.title || itemDetails.name} />
                    ) : (
                        <img className="w-100" src={`https://image.tmdb.org/t/p/w500/${itemDetails.profile_path}`} alt={itemDetails.title || itemDetails.name} />
                    )}
                </div>
                <div className="col-md-8">
                    <h2>{itemDetails.title || itemDetails.name}</h2>
                    <p className="py-2 text-secondary">{itemDetails.overview}</p>
                    <ul className="list-unstyled mt-3">
                        {itemDetails.release_date && (
                            <li className='text-secondary'><strong>Release Date:</strong> {itemDetails.release_date}</li>
                        )}
                        {itemDetails.runtime && (
                            <li className='text-secondary'><strong>Runtime:</strong> {itemDetails.runtime} minutes</li>
                        )}
                        {itemDetails.popularity && (
                            <li className='text-secondary'><strong>Popularity:</strong> {itemDetails.popularity}</li>
                        )}
                        {itemDetails.genres && itemDetails.genres.length > 0 && (
                            <li className='text-secondary'><strong>Genres:</strong> {itemDetails.genres.map(genre => genre.name).join(', ')}</li>
                        )}
                        {itemDetails.budget && (
                            <li className='text-secondary' ><strong>Budget:</strong> ${itemDetails.budget.toLocaleString()}</li>
                        )}
                        {itemDetails.revenue && (
                            <li className='text-secondary'><strong>Revenue:</strong> ${itemDetails.revenue.toLocaleString()}</li>
                        )}
                        {itemDetails.first_air_date && (
                            <li className='text-secondary'><strong>First Air Date:</strong> {itemDetails.first_air_date}</li>
                        )}
                        {itemDetails.known_for_department && (
                            <li className='text-secondary'><strong>Known For:</strong> {itemDetails.known_for_department}</li>
                        )}
                    </ul>
                    {itemDetails.vote_average && (
                        <div className="vote p-2 text-white bg-primary rounded w-auto d-inline-block">
                            {itemDetails.vote_average.toFixed(1)}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
